/*
 * Garde-fou commun à TOUS les formulaires de recherche du site.
 *
 * Il vit ici, et non dans le module de l'assistant RAG, délibérément : c'est ce
 * qui évite la régression classique. Débrancher l'assistant emporte l'attribut
 * `data-rag-search` — si la touche Entrée et le contrôle de longueur n'avaient
 * de copie que dans ce module-là, ils disparaîtraient avec lui, sans que rien
 * ne le signale.
 *
 * Se pose sur n'importe quel formulaire portant `data-search-form` : il n'y a
 * pas de liste à tenir, poser l'attribut suffit.
 */

const MIN_LENGTH_DEFAULT = 2;

function guardMinLength(form) {
    const min = parseInt(form.dataset.minLength || MIN_LENGTH_DEFAULT, 10);

    form.addEventListener('submit', (e) => {
        const field = form.querySelector('textarea[name="q"], input[name="q"]');
        const value = field ? field.value.trim() : '';

        if (value.length >= min) return;

        // Bloque AVANT l'écouteur de l'assistant, qui teste `e.defaultPrevented`.
        e.preventDefault();
        if (field) field.focus();

        const notice = form.querySelector('[data-search-notice]');
        if (notice) {
            notice.textContent = notice.dataset.searchNotice || '';
            notice.hidden = false;
        }
    });
}

/*
 * Dans un <textarea>, Entrée insère un retour à la ligne, elle ne soumet pas :
 * le champ a l'air parfait, le bouton marche, et la touche est muette.
 * `requestSubmit()` et JAMAIS `submit()` — seul le premier déclenche
 * l'événement `submit`, donc le garde-fou ci-dessus ; un `submit()` direct
 * partirait sur une seule lettre.
 */
function wireTextareaEnter(field) {
    const form = field.closest('form');
    if (!form) return;

    field.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' || e.shiftKey) return;
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
    });
}

function autoGrow(field) {
    const resize = () => {
        field.style.height = 'auto';

        /*
         * `scrollHeight` mesure le contenu PLUS les retraits, mais PAS les
         * bordures. Or ces champs sont en `box-sizing: border-box` : poser
         * `height = scrollHeight` sur un champ bordé laisse donc manquer
         * l'épaisseur des bordures, le contenu déborde de deux pixels, et une
         * barre de défilement apparaît dans un champ d'une seule ligne.
         * Mesuré : scrollHeight 52 pour un clientHeight de 50.
         * Sur un champ sans bordure la correction vaut 0 — elle est donc sans
         * effet là où le problème ne se pose pas.
         */
        const cs = window.getComputedStyle(field);
        const bordures = cs.boxSizing === 'border-box'
            ? parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth)
            : 0;

        field.style.height = (field.scrollHeight + bordures) + 'px';
    };
    field.addEventListener('input', resize);
    // Un textarea restauré par le bfcache ne déclenche PAS d'événement `input` :
    // sans cet appel au démarrage, le champ reste sur une ligne sous trois lignes
    // de texte.
    resize();
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[data-search-form]').forEach(guardMinLength);
    document.querySelectorAll('textarea[data-search-textarea]').forEach((field) => {
        wireTextareaEnter(field);
        autoGrow(field);
    });
});
